export default (arrayItems, item) => arrayItems.includes(item);